import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: "Je n'ai pas la main verte, je tue même mes cactus.",
  a: "C'est pour ça que ce n'est pas un livre de jardinage, c'est un système. Suivez les étapes, installez le substrat, et la nature fera le reste."
}, {
  q: 'Est-ce que ça prend beaucoup de place ?',
  a: 'Le système est optimisé pour 1m². Si vous avez une chaise sur votre balcon, vous avez assez de place.'
}, {
  q: 'Quand vais-je voir les premiers résultats ?',
  a: 'Certaines cultures (Micro-pousses et radis) se récoltent en seulement 7 à 21 jours.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream-dark/30 py-24 px-6" data-id="element-51">
      <div className="max-w-[800px] mx-auto" data-id="element-52">
        <div className="text-center mb-16" data-id="element-53">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-54">
            Questions Fréquentes
          </h2>
          <p className="font-sans text-charcoal/60 uppercase tracking-widest text-sm" data-id="element-55">
            FAQ Sniper
          </p>
        </div>

        <div className="space-y-4" data-id="element-56">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-sm border border-cream-dark overflow-hidden" data-id="element-57">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-58">
                <span className="font-serif text-lg md:text-xl font-bold text-charcoal pr-8" data-id="element-59">
                  "{faq.q}"
                </span>
                <ChevronDown className={`w-6 h-6 text-forest flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-60" />
              </button>

              <AnimatePresence data-id="element-61">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-62">
                    <div className="px-6 pb-6 pt-2 border-t border-cream-dark/50" data-id="element-63">
                      <p className="font-sans text-charcoal/80 leading-relaxed" data-id="element-64">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}